<script>
  import { createEventDispatcher, onMount } from "svelte"
  import notify from "../../../../../../Script/notify"
  import Badge from "./badge.svelte"
  const dispatch = createEventDispatcher()

  export let placement

  export let index

  export let currentpage

  export let isInternalUser = false

  export let pdfHasDifferentSize = false

  export let totalPages = 1

  export let role

  let isCustom = true

  let pageNo

  /**
   * @typedef {Object} closeNotification
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {closeNotification}
   */
  let closeNotification = {
    close() {},
  }

  onMount(() => {
    try {
      if (isNaN(placement.pages)) isCustom = false
      else {
        pageNo = placement.pages + 1 || currentpage
      }
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: Docket Creation (Signing Widget)\nEVENT: onMount"
      closeNotification = notify.danger(error, info)
    }
  })

  // $: pageChange(pageNo)

  const pageChange = (pageNo) => {
    try {
      if (pageNo > totalPages) throw `PDF has only ${totalPages} pages.`
      if (Number(pageNo)) {
        const prevPage = placement.pages
        placement.pages = Number(pageNo) - 1
        dispatch("pageChange", { current: pageNo, prev: prevPage })
      }
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: Docket Creation (Signing Widget)\nEVENT: On PDF page change"
      closeNotification = notify.danger(error, info)
    }
  }

  const handleMultiPageSelection = (type) => {
    placement.pages = type
    isCustom = false
    if (pdfHasDifferentSize) dispatch("pdfCheck")
  }
</script>

<div class="min-h-[36px] w-full space-y-2 rounded-md border-2 bg-[#f7f7f7] px-3 py-2 dark:bg-gray-c00 {placement.error ? 'border-red-500' : placement.default ? 'border-green-500' : 'border-transparent'} ">
  <div class="flex w-full items-center justify-between">
    <div class="flex items-center gap-3">
      <p class="text-sm font-medium capitalize text-gray-g00">{role} Placement {index + 1}</p>
      {#if placement.default}
        <div class="rounded-md bg-green-500 px-2 py-1 text-[10px] font-semibold tracking-wide text-white">DEFAULT</div>
      {/if}
    </div>
    <button type="button" on:click class="hover:text-red-500 dark:text-white dark:hover:text-red-500">
      <i class="fa-solid fa-trash-can" />
    </button>
  </div>

  {#if totalPages > 1}
    <!-- {#if !isInternalUser && role != "Approver"}
      <div class="flex items-center gap-2">
        <Badge
          on:click={() => {
            placement.pages = "ODD"
            isCustom = false
          }}
          btnName={"Odd"}
          btnclr={"blue"}
          active={placement.pages == "ODD"}
        />
        <Badge
          on:click={() => {
            placement.pages = "EVEN"
            isCustom = false
          }}
          btnName={"Even"}
          btnclr={"blue"}
          active={placement.pages == "EVEN"}
        />
        <Badge
          on:click={() => {
            placement.pages = "ALL"
            isCustom = false
          }}
          btnName={"All"}
          btnclr={"blue"}
          active={placement.pages == "ALL"}
        />
        <Badge
          on:click={() => {
            isCustom = true
            pageNo = currentpage
            placement.pages = currentpage - 1
          }}
          btnName={"Custom"}
          btnclr={"blue"}
          active={placement.pages != "ODD" && placement.pages != "EVEN" && placement.pages != "ALL"}
        />
      </div>
    {/if} -->
    {#if !isInternalUser && role != "Approver" && !pdfHasDifferentSize}
      <div class="flex items-center justify-between gap-2">
        <p class="text-gry-g00 text-sm">Page Selection</p>
        <div class="w-fit rounded-full bg-blue-500 p-1 text-xs dark:bg-lightgray">
          <button
            type="button"
            on:click={() => {
              isCustom = true
              placement.pages = currentpage - 1
              pageNo = currentpage
              pageChange(currentpage)
            }}
            class="{isCustom ? 'bg-white text-blue-500 dark:bg-blue-500 dark:text-white' : 'text-white'} rounded-full px-2 text-center font-medium"
          >
            Normal
          </button>
          <button
            type="button"
            on:click={() => {
              try {
                // if (pdfHasDifferentSize) throw "Advanced mode isn’t supported because the PDF contains pages with different dimensions."
                isCustom = false
                placement.pages = "ALL"
                // if (pdfHasDifferentSize) dispatch("pdfCheck")
              } catch (error) {
                notify.danger(error)
              }
            }}
            class="{!isCustom ? 'bg-white text-blue-500 dark:bg-blue-500 dark:text-white' : 'text-white'} rounded-full px-2 text-center font-medium"
          >
            Advanced
          </button>
        </div>
      </div>
    {/if}
    {#if isCustom || isInternalUser}
      <div class="group flex w-full select-none items-center gap-3 rounded-md border border-[#a0a1a580] bg-transparent p-2 text-sm focus-within:border-blue-500">
        <div class="font-bold text-gray-g00 group-focus-within:text-blue-500">PAGE</div>
        <input
          on:keypress={(e) => {
            let preventedKeys = ["e", "E", "-", "+"]
            if (preventedKeys.includes(e.key)) e.preventDefault()
          }}
          on:blur={() => {
            if (!pageNo) pageNo = placement.pages + 1
          }}
          on:input={(e) => {
            pageChange(e.target.value)
          }}
          value={pageNo}
          type="number"
          min="1"
          max={totalPages}
          placeholder="Enter Page number"
          class="w-full bg-transparent text-black outline-none dark:text-white"
        />
      </div>
    {:else}
      <div class="flex items-center justify-between gap-2">
        <div class="flex items-center gap-2">
          <Badge
            on:click={() => {
              handleMultiPageSelection("ALL")
            }}
            btnName={"All"}
            btnclr={"blue"}
            active={placement.pages == "ALL"}
          />
          <Badge
            on:click={() => {
              handleMultiPageSelection("ODD")
            }}
            btnName={"Odd"}
            btnclr={"blue"}
            active={placement.pages == "ODD"}
          />
          <Badge
            on:click={() => {
              handleMultiPageSelection("EVEN")
            }}
            btnName={"Even"}
            btnclr={"blue"}
            active={placement.pages == "EVEN"}
          />
        </div>
        <div class="group relative cursor-pointer">
          <div class="absolute right-0 -top-12 z-20 hidden w-[300px] rounded-md border border-stone-700 bg-white p-2 text-xs font-normal text-black group-hover:block dark:bg-black dark:text-white">Advanced Page Selections are only applicable in E-Sign Signing mode.</div>
          <!-- <div class="absolute -left-[150px] -top-[75px] z-20 hidden w-[300px] rounded-md border border-stone-700 bg-white p-2 text-xs font-normal text-black group-hover:block dark:bg-black dark:text-white">For DSC Digital Signing (Dongle) and Aadhaar E-Sign, only the default placement is considered for signing. However, for eSign, there are no such limitations.</div> -->
          <span>
            <i class="fa-solid fa-circle-info" />
          </span>
        </div>
      </div>
    {/if}
  {/if}
</div>
